import {useState} from "react";

export function useReviews(reviews = []) {
    const [type, setType] = useState('all');
    const [visibleCount, setVisibleCount] = useState(2);
    const [expanded, setExpanded] = useState({});

    const reviewsWithImages = reviews.filter(el => el.img);

    const currentReviews = type === 'all' ? reviews : reviewsWithImages;

    const visibleReviews = currentReviews.slice(0, visibleCount);

    const toggleExpand = (id) => {
        setExpanded(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    const showMore = () => {
        setVisibleCount(prev => prev + 2);
    };

    const changeType = (newType) => {
        if (newType === type) return;

        setType(newType);
        setVisibleCount(2);
    };

    return {
        type,
        visibleReviews,
        reviewsWithImages,
        showMore,
        toggleExpand,
        expanded,
        changeType,
        hasMore: currentReviews.length > visibleCount,
    };
}
